export default "__VITE_ASSET__ClmldxkL__"